import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import classes from "./index.module.scss";
import Reveal from "../../Utils/Reveal";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HomeService } from "../../services/homeService";

const InNews = () => {
  const [previews, setPreviews] = useState([]);

  useEffect(() => {
    const fetchPreviews = async () => {
      try {
        const res = await HomeService.GetInNews();
        if (Array.isArray(res.data?.data)) {
          setPreviews(res.data.data.filter((item) => !!item.preview));
        }
      } catch (error) {
        console.error("Error fetching inNews", error);
      }
    };

    fetchPreviews();
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {previews.length > 0 ? (
        <div className={classes.Container}>
          <Reveal>
            <div className={classes.ContainerHeader}>In News</div>
            <hr className={classes.ContainerHeaderBorder} />
          </Reveal>
          <div className={classes.CarouselParent}>
            <Reveal>
              <div className={classes.CarouselContainer}>
                <Slider {...settings}>
                  {previews.map((preview, index) => (
                    <div>
                      <a
                        className={classes.Card}
                        key={index}
                        target="_blank"
                        href={preview.url}
                      >
                        <img
                          src={preview.preview}
                          alt={preview.title}
                          className={classes.CardImage}
                        />

                        <div className={classes.CardText}>{preview.title}</div>
                      </a>
                    </div>
                  ))}
                </Slider>
              </div>
            </Reveal>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default InNews;
